<template>
    <div class="header">
        <div class="header-wrapper">
            <div class="header-left">
                <router-link to="/" class="logo" v-if="visuals.logo">
                        <img :alt="visuals.name" :src="visuals.logo" />
                </router-link>
            </div>
            <div class="header-right" v-if="visuals.headerText" v-html="visuals.headerText">
            </div>
            <div class="share-wrap" v-if="mode == 'paid'" v-click-outside="onClosePopup">
                <button class="share" @click.prevent="onShowPopup">
                    <i class="icon-share"></i>
                    <div class="share__text">Поделиться</div>
                </button>
                <share v-if="isShowShare" @close-popup="onClosePopup" />
            </div>
        </div>
    </div>
</template>

<script>
import Share from "../Share/index";
import ClickOutside from "vue-click-outside";
export default {
    name: "Header",
    components: { Share },
    data() {
        return {
            isShowShare: false
        };
    },
    computed: {
        mode() {
            return this.$store.getters.mode;
        },
        visuals() {
            return this.$store.getters.visuals || {};
        },
    },
    methods: {
        onClosePopup() {
            this.isShowShare = false;
        },
        onShowPopup() {
            this.isShowShare = true;
        }
    },

    directives: {
        ClickOutside
    }
};
</script>
